import React from "react";
import {
  Dialog,
  DialogContent,
  DialogActions,
  Button,
  Box,
  IconButton,
  Typography,
} from "@mui/material";
import {
  Close as CloseIcon,
  Download as DownloadIcon,
  ZoomIn as ZoomInIcon,
  ZoomOut as ZoomOutIcon,
} from "@mui/icons-material";

const ImageViewer = ({ open, imageSrc, imageTitle, onClose }) => {
  const [zoom, setZoom] = React.useState(1);

  const handleZoomIn = () => {
    setZoom((prev) => Math.min(prev + 0.2, 3));
  };

  const handleZoomOut = () => {
    setZoom((prev) => Math.max(prev - 0.2, 0.5));
  };

  const handleDownload = () => {
    if (!imageSrc) return;

    const link = document.createElement("a");
    link.href = imageSrc;
    link.download = imageTitle || "imagen";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const handleResetZoom = () => {
    setZoom(1);
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="lg" fullWidth>
      <DialogContent
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          minHeight: "500px",
          position: "relative",
          bgcolor: "#000",
          overflowY: "auto",
        }}
      >
        {/* Header con título y botones */}
        <Box
          sx={{
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            p: 2,
            bgcolor: "rgba(0,0,0,0.7)",
            backdropFilter: "blur(10px)",
            zIndex: 10,
          }}
        >
          <Typography
            variant="h6"
            sx={{ color: "white", flex: 1, ml: 2 }}
            noWrap
          >
            {imageTitle}
          </Typography>
          <Box>
            <IconButton
              size="small"
              onClick={handleZoomIn}
              sx={{ color: "white", mr: 1 }}
              title="Ampliar"
            >
              <ZoomInIcon />
            </IconButton>
            <IconButton
              size="small"
              onClick={handleZoomOut}
              sx={{ color: "white", mr: 1 }}
              title="Reducir"
            >
              <ZoomOutIcon />
            </IconButton>
            <IconButton
              size="small"
              onClick={handleResetZoom}
              sx={{ color: "white", mr: 1 }}
              title="Restablecer zoom"
            >
              <Typography variant="caption" sx={{ color: "white" }}>
                {Math.round(zoom * 100)}%
              </Typography>
            </IconButton>
            <IconButton
              size="small"
              onClick={onClose}
              sx={{ color: "white" }}
              title="Cerrar"
            >
              <CloseIcon />
            </IconButton>
          </Box>
        </Box>

        {/* Imagen */}
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flex: 1,
            width: "100%",
            mt: 6,
            overflow: "auto",
          }}
        >
          {imageSrc && (
            <img
              src={imageSrc}
              alt={imageTitle}
              style={{
                maxWidth: "100%",
                maxHeight: "100%",
                transform: `scale(${zoom})`,
                transition: "transform 0.2s ease",
                cursor: "zoom-in",
              }}
              onDoubleClick={handleResetZoom}
            />
          )}
        </Box>
      </DialogContent>

      {/* Footer con botones */}
      <DialogActions
        sx={{
          bgcolor: "background.paper",
          p: 2,
          borderTop: "1px solid",
          borderColor: "divider",
        }}
      >
        <Button
          onClick={handleDownload}
          startIcon={<DownloadIcon />}
          variant="outlined"
          size="small"
        >
          Descargar
        </Button>
        <Button onClick={onClose} variant="contained">
          Cerrar
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ImageViewer;
